<template>
 <div class="our-clients-page">

   <testimonial
   testimonial-name="Ognen Trajkovski"
   testimonial-company="Vitech  DevelopmentDevelopmentDevelopmentDevelopment"
   />


   </div>



 </div>
</template>

<script>
 import ProjectSection1 from "../sections/ProjectSection1";
 import ProjectsPageNavBar from "../components/ProjectsPageNavBar";
 import Testimonial from "../components/Testimonial";
 export default {
  name: 'OurClientsPage',
   components: {Testimonial},
 }
</script>

<style lang="scss">
@import "OurClientsPage";
</style>
